module.exports = __webpack_public_path__ + "img/spiral-details7.8afaf050.png";